<template>
  <!-- 日次締め -> 劇場前売券/優待券 -> 過不足精算表 || Get exact same data from 全レジ金額の内訳計算表 and calculate data -->
  <el-table
    :data="blendData"
    :span-method="spanMethod"
    :row-class-name="rowClassName"
    class="egl-table excess-deficiency-settlement-table"
    stripe
    border
  >
    <!-- 売掛金種別 -->
    <el-table-column
      prop="type"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.th.ticketType')"
      width="140"
      align="center"
    >
      <template slot-scope="scope">
        <span v-if="scope.row.rowType !== 'total'" :class="[scope.row.rowType === 'subtotal' ? 'sub-total-row' : '' ]">
          {{ accountsReceivableType[scope.row.type] }}
        </span>
        <div v-else style="text-align: center">{{ scope.row.type }}</div>
      </template>
    </el-table-column>

    <!-- 売掛金名 -->
    <el-table-column
      prop="name"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.th.accountReceivableName')"
      width="180"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.name }}
      </template>
    </el-table-column>

    <!-- 日次実件数 -->
    <el-table-column
      prop="dayActualQty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.th.dayActualQty')"
      width="110"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.dayActualQty | separatorFormatter }}</div>
      </template>
    </el-table-column>

    <!-- 合計過不足（件数）= レジ過不足（件数） + 日次過不足（件数） -->
    <el-table-column
      prop="insufficientTotal"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.th.insufficientTotal')"
      width="150"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">
          {{ scope.row.insufficientTotal | separatorFormatter }}
          <!-- {{ (scope.row.actualQty - scope.row.qty) + (scope.row.dayActualQty - scope.row.actualQty) | separatorFormatter }} -->
        </div>
      </template>
    </el-table-column>

    <!-- レジ過不足（件数） = レジ実件数 - レジ理論件数 -->
    <el-table-column
      prop="cashQty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.th.cashQty')"
      width="150"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.cashQty | separatorFormatter }}</div>
        <!-- <div class="ta-r">{{ scope.row.actualQty - scope.row.qty | separatorFormatter }}</div> -->
      </template>
    </el-table-column>

    <!-- 日次過不足（件数） = 日次実件数 - レジ実件数 -->
    <el-table-column
      prop="dayQty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.th.dayQty')"
      min-width="50"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.dayQty | separatorFormatter }}</div>
        <!-- <div class="ta-r">{{ scope.row.dayActualQty - scope.row.actualQty | separatorFormatter }}</div> -->
      </template>
    </el-table-column>

    <!-- 日次実売上 -->
    <el-table-column
      prop="actualSales"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.th.actualSales')"
      min-width="50"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.actualSales | currencyFormatter }}</div>
        <!-- <div class="ta-r">{{ scope.row.amount / scope.row.qty * scope.row.dayActualQty | currencyFormatter }}</div> -->
      </template>
    </el-table-column>

    <!-- 合計過不足（売上）= レジ過不足（売上）+ 日次過不足（売上） -->
    <el-table-column
      prop="saleQty"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.th.saleQty')"
      min-width="50"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{scope.row.saleQty | currencyFormatter}}</div>
        <!-- <div class="ta-r">{{ (scope.row.actualAmount - scope.row.amount) + (scope.row.amount / scope.row.qty * scope.row.dayActualQty - scope.row.actualAmount) | currencyFormatter }}</div> -->
      </template>
    </el-table-column>

    <!-- レジ過不足（売上）= レジ実売上 - レジ理論売上 -->
    <el-table-column
      prop="cashBalance"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.th.cashBalance')"
      min-width="50"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{ scope.row.cashBalance | currencyFormatter }}</div>
        <!-- <div class="ta-r">{{ scope.row.actualAmount - scope.row.amount | currencyFormatter }}</div> -->
      </template>
    </el-table-column>

    <!-- 日次過不足（売上）= 日次実売上 - レジ実売上 -->
    <el-table-column
      prop="dayInsufficient"
      :label="$locale('dailyClosing.theaterAdvanceTicketTable.theaterExcessDeficiencySettlementTable.th.dayInsufficient')"
      min-width="50"
      align="center"
    >
      <template slot-scope="scope">
        <div class="ta-r">{{scope.row.dayInsufficient | currencyFormatter}}</div>
        <!-- <div class="ta-r">{{ scope.row.amount / scope.row.qty * scope.row.dayActualQty - scope.row.actualAmount | currencyFormatter }}</div> -->
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import { ticketDetailResStruct } from "@/assets/js/dailyClosingNew";

export default {
  name: "TicketReplacement",
  props: {
    accountsReceivableType: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Object,
      default: () => ({
        couponType: [],
        nationalTicket: [],
        settlement: [],
      }),
    },
    actionType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    blendData() {
      const _values = Object.values(this.tableData).find(_val => _val.length !== 0);
      if (!_values) { return []; }

      const _totalBase = ticketDetailResStruct();
      _totalBase.type = this.$locale("global.total");
      _totalBase.rowType = "total";

      const _tableData = tranfResData(this.tableData);
      let resultArray = [];

      const _addPropFn = (objArray, type) => {
        const _subTotalBase = ticketDetailResStruct();

        objArray.forEach((_item, i) => {
          _item.type = type;
          _item.index = i;

          let { actualAmount, amount, dayActualQty, qty, actualQty } = _item;
          const _cashQty = actualQty - qty;
          const _dayQty = dayActualQty - actualQty;
          const _cashBalance = actualAmount - amount;
          const _actualSales = amount / qty * dayActualQty;
          const _saleQty = _cashBalance + _actualSales;
          const _dayInsufficient = _actualSales - actualAmount;
          const _insufficientTotal = _cashQty + _dayQty;

          _item.cashQty = _cashQty;
          _item.saleQty = _saleQty;
          _item.dayQty = _dayQty;
          _item.cashBalance = _cashBalance;
          _item.dayInsufficient = _dayInsufficient;
          _item.insufficientTotal = _insufficientTotal;

          if (i === 0) {
            _item.rowspan = objArray.length + 1;
            _item.colspan = 1;
          } else {
            _item.rowspan = 0;
            _item.colspan = 0;
          }

          for (let __key in _subTotalBase) {
            if (typeof _item[__key] === "number") {
              _subTotalBase[__key] += _item[__key];
              _totalBase[__key] += _item[__key];
            } else if (__key === "name") {
              _subTotalBase[__key] = this.accountsReceivableType[_item.type] + " " + this.$locale("global.total");
            }
          }
        });

        objArray.push({
          ..._subTotalBase,
          rowType: "subtotal",
          type,
        });

        return objArray;
      };

      Object.keys(_tableData).forEach(_key => {
        if (_tableData[_key].length > 0) {
          const _subList = _addPropFn(_tableData[_key], _key);
          resultArray.push(..._subList);
        }
      });

      resultArray.push(_totalBase);

      return resultArray;
    },
  },
  methods: {
    spanMethod({ row, columnIndex }) {
      const { rowspan, colspan, rowType } = row;

      if (columnIndex === 0) {
        if (rowType === "total") {
          return [1, 2];
        }
        return [rowspan, colspan];
      } else if (columnIndex === 1 && rowType === "total") {
        return [0, 0];
      }
    },
    rowClassName({ row }) {
      //for handle some of the row need to be highlighted in table
      if (row.rowType === "subtotal") {
        return "sub-total-row";
      } else if (row.rowType === "total") {
        return "total-row";
      } else if (row.rowType === "empty-row") {
        return "empty-row";
      }
      return "other-row";
    },
  },
};
</script>